export enum OperationTypeEnum {
  DEFAULT = 'DEFAULT',
  SEVERE = 'SEVERE',
  ROAD = 'ROAD',
  MIXED = 'MIXED',
  HOURS = 'HOURS',
  YEARS = 'YEARS',
}
